<template>
  <div>
    <div class="head-box">
      <h4>报单分享</h4>
      <div class="c-flex"></div>
    </div>
    <div style="display: flex;align-items: center;">
      分享二维码：
      <div class="qrcode" style="margin:20px 0 0 10px" ref="qrCodeUrl"></div>
    </div>

    <div style="margin-top:20px">
      分享长链接：
      <el-link
        :href="
          `${href}?tenantId=${profile._id}&userId=${profile.user}&colName=declaration&h5UserId=${profile.entityId}`
        "
        target="_blank"
      >
        {{
          `${href}?tenantId=${profile._id}&userId=${profile.user}&colName=declaration&h5UserId=${profile.entityId}`
        }}
      </el-link>
    </div>
    <div style="margin-top:20px">
      分享短链接：
      <el-button style="margin-right:10px" @click="getShort">获取短链接</el-button>
      <el-link :href="`http://${shortUrl}`" target="_blank">{{ `${shortUrl}` }}</el-link>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  activated() {
    window.$this = this;
  },
  name: 'Declaration',
  data() {
    return {
      profile: {},
      href: '',
      shortUrl: ''
    };
  },
  mounted() {
    window.$this = this;
    this.href = location.href.replace('Declaration', 'h5/#/pages/extForm/extForm');
    this.init();
  },
  //引用父页面方法
  inject: ['logout', 'getProfile'],
  methods: {
    init() {
      this.getProfileInfo();
      // this.getDemo();
    },
    getShort() {
      let str = `${this.href}?tenantId=${this.profile._id}&userId=${this.profile.user}&colName=declaration&h5UserId=${this.profile.entityId}`;
      this.osg.ajax(
        'shortLink/createShortLink.do',
        {
          url: str
        },
        res => {
          this.shortUrl = res;
        }
      );
    },
    //获取当前租户信息，生成二维码
    getProfileInfo() {
      this.profile.user = JSON.parse(sessionStorage['entity'])._id; //租户管理员ID
      this.profile._id = JSON.parse(sessionStorage['entity']).tenantId; //租户账号ID
      this.profile.entityId = JSON.parse(sessionStorage['entity']).entityID; //当前登录账号的userId
      // console.log(tenantID);
      // this.osg.ajax(`tenant/find/${tenantID}.do`, {}, res => {
      //   this.profile = res.entity;
      this.$nextTick(() => {
        this.bindQRCode();
      });
      // });
    },
    bindQRCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: `${this.href}?tenantId=${this.profile._id}&userId=${this.profile.user}&colName=declaration&h5UserId=${this.profile.entityId}`,
        width: 200,
        height: 200,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    }
    // getDemo() {
    //   this.osg.ajax(
    //     "document/createWarrantyPDF.do?orderId=4401283674550519121",
    //     {},
    //     res => {}
    //   );
    // }
  }
};
</script>

<style scoped></style>
